import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FiltersState } from '../../models/filter.model';

// Selecciona el estado global de filtros
export const selectFiltersState = createFeatureSelector<FiltersState>('filters');

// Selector para obtener todos los filtros
export const selectAllFilters = createSelector(
  selectFiltersState,
  (state: FiltersState) => state.filters
);

// Selector para obtener un filtro específico por clave
export const selectFilterByKey = (key: keyof FiltersState) =>
  createSelector(selectFiltersState, (state: FiltersState) => state[key]);